<template>
    <section class="user-profile-content-wrapper pb-80px">
        <div class="container">
            <div class="row responsive-tablet-col-1">
                <div class="col-md-2">
                    <questions-sidebar />
                </div>
                <div class="col-md-10">
                    <el-tabs v-model="activeName" class="user-profile-tabs">
                        <el-tab-pane label="Profile" name="profile">
                            <user-profile-tab-default />
                        </el-tab-pane>
                        <el-tab-pane label="Activity" name="activity">
                            <user-profile-tab-activity />
                        </el-tab-pane>
                        <el-tab-pane label="Settings" name="settings">
                            <user-profile-settings />
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import UserProfileSettings from '../pieces/UserProfile/_UserProfileSettings.vue'
import QuestionsSidebar from '../sidebars/QuestionsSidebar.vue'
import UserProfileTabActivity from './UserProfileTabActivity.vue'
import UserProfileTabDefault from "./UserProfileTabDefault.vue"


export default {
    name: 'UserProfileContent',
    components: {
        UserProfileTabDefault,
        QuestionsSidebar,
        UserProfileTabActivity,
        UserProfileSettings,
    },
    data() {
        return {
            activeName: 'profile'
        }
    }
}
</script>